import React from "react";

import { Image } from "react-bootstrap";
import { Tournament } from "@nestcoinco/hyper-api-gateway-api-client";
import { useNavigate } from "react-router-dom";

import "./GatheringInfo.scss";
import { type IOpponentSummary } from "../../../jotai/atoms/tournament";
import { GameOutcome as Outcome } from "../../../utils/constants";
import ParticipantResult from "../../game-results-page/ParticipantResult/ParticipantResult";
import GhostButton from "../../dashboard-page/GhostButton/GhostButton";
import { ROUTES } from "../../../utils/constants";
import LoadingOverlay, {
  OverlayVariant,
} from "../../LoadingOverlay/LoadingOverlay";
import useAuth from "../../../hooks/useAuth";

interface GatheringInfoProps {
  duelOpponent: IOpponentSummary | null;
  tournamentDetails?: Tournament;
}

function GatheringInfo({
  duelOpponent,
  tournamentDetails,
}: GatheringInfoProps) {
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  return (
    <div className="d-flex flex-column justify-content-between h-100 pb-5">
      <div className="gathering-info ">
        <p className="d-flex justify-content-center mb-2">
          <Image
            src={tournamentDetails?.game?.thumbnail}
            alt="game banner"
            width={34}
          />
        </p>

        <p className="game-title slashed-zero text-uppercase">
          {tournamentDetails?.game?.name}
        </p>
        <h1 className="main-heading slashed-zero">Please wait</h1>
      </div>
      <div className="gathering-info d-flex align-items-center justify-content-evenly position-relative ">
        <ParticipantResult
          outcome={Outcome.AWAITING_SCORE}
          isLoggedInUser
          username={userProfile?.username}
          avatar={userProfile?.avatar?.url}
          isForLoader
        />
        <p className="versus">vs</p>
        <ParticipantResult
          outcome={Outcome.AWAITING_SCORE}
          username={duelOpponent?.username}
          avatar={duelOpponent?.avatar}
          isForLoader
        />
      </div>
      <div className="px-3">
        <GhostButton
          className="home-btn mx-auto text-white py-3 mt-1 w-100 rounded-3"
          onClick={() => navigate(`${ROUTES.GAMES.ROOT}`)}
          style={{ background: "#FFFFFF0D" }}
          disabled
        >
          Go Home
        </GhostButton>
      </div>
      <LoadingOverlay
        variant={OverlayVariant.GATHERING_INFO}
        loadingText="Fetching results"
      />
    </div>
  );
}

export default GatheringInfo;
